module.exports = __webpack_public_path__ + "static/media/f_eyeshape_upturned_hazel.5c6c6671.png";